const CheckoutStepper = {
    formularioDatosPersonales: 1,
    formularioPago: 2,
    formularioDomicilio: 3,
    ventaFinalizada: 4,
    ventaCancelada: 5,
};

export default CheckoutStepper;